/*
  Dossha module tracking.

  Sends GA4 events for the PDP "Kombinini Tamamla" slider and the cart upsell:
    dossha_module_view         module shown on screen (once per module per page)
    dossha_module_click        product link clicked inside the module
    dossha_module_add_to_cart  product added to cart from the module

  module_location: pdp | cart_drawer | cart_page
  ab_variant / ab_test_id are copied from ab-test-ga4.

  PDP adds also write the cart attributes pdp_kombin / pdp_kombin_items so the
  order shows the source, like the cart upsell's cart_boost / cart_boost_items.
*/
(function () {
  if (window.__dosshaModuleTracking) return;
  window.__dosshaModuleTracking = true;

  var MODULES = [
    {
      root: '.product__complementaries product-recommendations, product-recommendations.product-recommendations--pdp',
      card: '.pdp-ctl-card',
      link: 'a.pdp-ctl-card__media, a.pdp-ctl-card__title',
      add: '.pdp-ctl-card__add',
      name: 'kombinini_tamamla',
      location: function () { return 'pdp'; }
    },
    {
      root: 'dossha-cart-upsell',
      card: '.dossha-upsell__card',
      link: 'a.dossha-upsell__card-link',
      add: '.dossha-upsell__add-btn',
      name: 'sepet_onerileri',
      location: function (root) {
        return (root.getAttribute('data-area') || 'cart-drawer') === 'cart' ? 'cart_page' : 'cart_drawer';
      }
    }
  ];

  var ADD_WINDOW_MS = 8000;
  var seen = {};
  var pendingAdd = null;

  function abParams() {
    var params = {};
    try {
      params.ab_variant = sessionStorage.getItem('ab_variant') || undefined;
      params.ab_test_id = sessionStorage.getItem('ab_test_id') || undefined;
    } catch (error) {}
    return params;
  }

  function sourceProductId() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return meta && meta.product && meta.product.id ? String(meta.product.id) : undefined;
  }

  function send(name, params) {
    var payload = Object.assign({}, abParams(), params, { page_type: pageType() });
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(['event', name, payload]);
    }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) {}
  }

  function pageType() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return (meta && meta.page && meta.page.pageType) || undefined;
  }

  function handleFromUrl(href) {
    var match = /\/products\/([^/?#]+)/.exec(href || '');
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  function moduleFor(element) {
    for (var i = 0; i < MODULES.length; i++) {
      var root = element.closest(MODULES[i].root);
      if (root) return { config: MODULES[i], root: root };
    }
    return null;
  }

  /* View */
  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var viewportHeight = (entry.rootBounds && entry.rootBounds.height) || window.innerHeight;
          var needed = Math.min(entry.boundingClientRect.height, viewportHeight) * 0.5;
          if (entry.intersectionRect.height < needed) return;
          var found = moduleFor(entry.target);
          if (!found) return;
          var location = found.config.location(found.root);
          var cards = found.root.querySelectorAll(found.config.card).length;
          if (!cards || seen[location]) return;
          seen[location] = true;
          observer.unobserve(entry.target);
          send('dossha_module_view', {
            module_name: found.config.name,
            module_location: location,
            items_count: cards,
            source_product_id: sourceProductId()
          });
        });
      }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] })
    : null;

  function watchRoots() {
    if (!observer) return;
    MODULES.forEach(function (config) {
      document.querySelectorAll(config.root).forEach(function (root) {
        var target = root.querySelector(config.card) ? root : null;
        if (!target || target.__dosshaObserved) return;
        target.__dosshaObserved = true;
        observer.observe(target);
      });
    });
  }

  var scheduled = false;
  function scheduleWatch() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      watchRoots();
    }, 250);
  }

  new MutationObserver(scheduleWatch).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRoots);
  } else {
    watchRoots();
  }

  /* Click and add intent */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var found = moduleFor(target);
    if (!found) return;
    var config = found.config;
    var location = config.location(found.root);

    var addBtn = target.closest(config.add);
    if (addBtn) {
      if (addBtn.disabled) return;
      var variantId = addBtn.getAttribute('data-variant-id') || '';
      if (!variantId) return;
      var card = addBtn.closest(config.card);
      var link = card && card.querySelector(config.link);
      pendingAdd = {
        at: Date.now(),
        location: location,
        name: config.name,
        variantId: variantId,
        handle: addBtn.getAttribute('data-product-handle') || handleFromUrl(link && link.getAttribute('href'))
      };
      return;
    }

    var anchor = target.closest(config.link);
    if (anchor) {
      send('dossha_module_click', {
        module_name: config.name,
        module_location: location,
        item_handle: handleFromUrl(anchor.getAttribute('href')),
        source_product_id: sourceProductId(),
        transport_type: 'beacon'
      });
    }
  }, true);

  /* Add confirmation */
  function requestUrl(input) {
    if (typeof input === 'string') return input;
    return (input && input.url) || '';
  }

  function markPdpOrder(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var items = String((cart.attributes && cart.attributes.pdp_kombin_items) || '')
          .split(',')
          .map(function (value) { return value.trim(); })
          .filter(Boolean);
        if (handle && items.indexOf(handle) === -1) items.push(handle);
        var attributes = { pdp_kombin: 'true' };
        if (items.length) attributes.pdp_kombin_items = items.join(', ');
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () {});
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = requestUrl(input);
      var intent = pendingAdd;
      var isModuleAdd = intent && url.indexOf('/cart/add') !== -1 && Date.now() - intent.at < ADD_WINDOW_MS;
      if (isModuleAdd) pendingAdd = null;

      var request = originalFetch.apply(window, arguments);
      if (!isModuleAdd) return request;

      request
        .then(function (response) {
          if (!response.ok) return null;
          return response.clone().json();
        })
        .then(function (item) {
          if (!item || item.status) return;
          var price = typeof item.price === 'number' ? item.price / 100 : undefined;
          send('dossha_module_add_to_cart', {
            module_name: intent.name,
            module_location: intent.location,
            item_id: String(item.variant_id || intent.variantId),
            item_product_id: item.product_id ? String(item.product_id) : undefined,
            item_handle: item.handle || intent.handle,
            item_name: item.product_title,
            value: price,
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY',
            source_product_id: sourceProductId()
          });
          if (intent.location === 'pdp') markPdpOrder(item.handle || intent.handle);
        })
        .catch(function () {});

      return request;
    };
  }
})();
